module.exports = {
  port: Number(process.env.PORT) || 3000,
}
